import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { mapMessageToProductImpression } from '@/common/analytics/gtm/mappers';
import { EventMessage } from '@/common/analytics/gtm/types';

export const trackUAProductImpression = (messages: EventMessage[]) => {
  createTrackingEvent({
    event: 'productImpression',
    ecommerce: {
      impressions: messages.map((message) => mapMessageToProductImpression(message)),
    },
  });
};
